import {ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormService, LangService, LoaderService, NavigateService} from 'ngx-satoris';
import {ApiService} from '../../../shared/services/api.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {Person, PersonLinkType} from '../../../shared/models/person';
import {environment} from 'src/environments/environment';
import {DocumentType} from '../../../shared/models/user';
import {enumToArrayObject} from 'src/app/shared/utils/enumToArrayObject';
import {RequestService} from 'src/app/shared/services/request.service';

import {warnIfInvalidName} from 'src/app/shared/utils/form';
@Component({
  selector: 'app-people-data-modification',
  templateUrl: './people-data-modification.component.html',
  styleUrls: ['./people-data-modification.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PeopleDataModificationComponent implements OnInit{

  form: FormGroup;
  submitted = false;
  userId = this.route.snapshot.paramMap.get('userId');
  actualPerson: Person;
  linkTypeOptions;
  otherOptions = false;
  sexOptions = [{name: 'DYN.male', value: 'M'}, {name: 'DYN.female', value: 'F'}, {name: 'DYN.other', value: '?'}];
  countriesOptions = this.request.getNationalities(false);

  constructor(public nav: NavigateService,
              private api: ApiService,
              private formBuilder: FormBuilder,
              public forms: FormService,
              private cdRef: ChangeDetectorRef,
              private loader: LoaderService,
              private lang: LangService,
              private route: ActivatedRoute,
              private request: RequestService) {
    this.linkTypeOptions = enumToArrayObject(PersonLinkType).filter((item) => +item.value !== PersonLinkType.UNKNOWN).map(item => ({
      name: 'personLinkType.DYN.' + item.value,
      value: item.value
    }));
  }

  ngOnInit(): void {
    this.actualPerson = this.api.listPersons.find((person: Person) => +person.id === +this.userId);
    if(this.actualPerson?.otherLinkType) {
      this.otherOptions = true;
    }
    this.setForm();
    this.cdRef.detectChanges();
  }

  setForm() {
    this.form = this.formBuilder.group({
      firstName: [this.actualPerson?.firstName, [
        Validators.pattern('[A-Za-z\' -]+'),
        Validators.maxLength(50)
      ]],
      lastName: [this.actualPerson?.lastName, [
        Validators.pattern('[A-Za-z\' -]+'),
        Validators.maxLength(50)
      ]],
      personalNr: [this.actualPerson?.nationalNumber, [
        Validators.pattern('[a-zA-Z0-9\-]+'),
        Validators.maxLength(20)
      ]],
      passportNr: [this.actualPerson?.passportNumber, [
        Validators.pattern('^[A-Z0-9]+$'),
        Validators.required,
        Validators.maxLength(20)
      ]],
      birthDate: [this.actualPerson?.birthDate || '', []],
      sex: [this.actualPerson?.sex || '', [
        Validators.pattern('^[MF\?]$')
      ]],
      birthPlaceCity: [this.actualPerson?.birthPlaceCity || '', [
        Validators.pattern('[A-Za-z\' -]+'),
        Validators.maxLength(50)
      ]],
      birthPlaceCountry: [this.actualPerson?.birthPlaceCountry || '', []],
      linkType: [this.actualPerson?.linkType, []],
      otherLinkType: [this.actualPerson?.otherLinkType, [
        Validators.pattern('[A-Za-z\' -]+'),
        Validators.maxLength(50),
        ...(this.actualPerson?.otherLinkType ? [Validators.required] : [])
      ]]
    });
    this.form.get('linkType').valueChanges.subscribe(value => {
      const otherLinkTypeControl = this.form.get('otherLinkType');
      if(+value === PersonLinkType.OTHER) {
        this.otherOptions = true;
        otherLinkTypeControl.setValue(this.actualPerson?.otherLinkType);
        otherLinkTypeControl.setValidators([Validators.required, Validators.pattern('[A-Za-zàáâãäåçèéêëìíîïðòóôõöùúûüýÿñÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÐÒÓÔÕÖÙÚÛÜÝŸÑ\'-\\s]+'), Validators.maxLength(50)]);
      } else {
        this.otherOptions = false;
        otherLinkTypeControl.setValue('');
        otherLinkTypeControl.setValidators([Validators.pattern('[A-Za-zàáâãäåçèéêëìíîïðòóôõöùúûüýÿñÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÐÒÓÔÕÖÙÚÛÜÝŸÑ\'-\\s]+'), Validators.maxLength(50)]);
      }
      otherLinkTypeControl.updateValueAndValidity();
    });
  }

  submit() {
    const firstName = this.form.get('firstName').value?.trim();
    const lastName = this.form.get('lastName').value?.trim();
    warnIfInvalidName(firstName, lastName, this.loader).then(canContinue => {
      if(!canContinue) {
        return;
      }
      this.submitUpdatePerson();
    });
  }

  private submitUpdatePerson(): void {
    const hasAtLeastOneName = this.form.get('firstName').value || this.form.get('lastName').value;
    if(this.forms.getFormErrors(this.form).length < 1 && hasAtLeastOneName) {
      this.loader.loading(true, {type: 'warn', message: this.lang.transform('personModification.ask.DYN.'), btnLabel: this.lang.transform('global.confirm')}).then((res: boolean) => {
        if(res) {
          this.loader.loading(true);
          this.api.updatePerson(
            this.actualPerson.id,
            this.form.get('personalNr').value,
            this.form.get('firstName').value || '',
            this.form.get('lastName').value || '',
            this.form.get('passportNr').value,
            +this.form.get('linkType').value,
            this.form.get('otherLinkType').value,
            this.form.get('birthDate').value ? new Date(this.form.get('birthDate').value) : undefined,
            this.form.get('sex').value,
            this.form.get('birthPlaceCity').value,
            this.form.get('birthPlaceCountry').value
          ).then(() => {
            this.loader.loading(false);
            this.loader.loading(true, {type: 'valid', message: 'personModification.valid.DYN.'}).then(() => {
              this.api.persons().then(res => {
                this.api.listPersons = res;
                this.nav.to('people'+ '/' + this.userId);
              });
            });
          }).catch((err) => {
            this.loader.loading(true, {type: 'error', message: err});
          });
        }
      });
    } else {
      this.submitted = true;
    }
  }
  protected readonly DocumentType = DocumentType;
  protected readonly environment = environment;
}
